import React from 'react';
import { reduxForm, Field } from 'redux-form';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import DropdownOutlet from 'components/Fields/ReduxForm/DropdownOutlet';
import DropdownCalendar from 'components/Fields/ReduxForm/DropdownCalendar';
import MultipleDropdownSelect from 'components/Fields/ReduxForm/MultipleDropdownSelect';
import SearchBar from 'components/Fields/ReduxForm/SearchBar';
import OutletModal from 'components/Fields/ReduxForm/OutletModal';
import MenuTitle from 'components/MenuTitle';
import { exportInvoices } from 'actions/reports/invoices';
import moment from 'moment';
import { isFullSiteMode } from 'utils/fullSite';
import { MenuItem } from 'react-bootstrap';
import Dropdown from 'components/Dropdown';
import { getFormattedTime } from 'utils/hourFilter';
import styleActionBar from './ActionBar.css';

class ActionBar extends React.Component {
  static INVOICE_STATUS = {
    cancelled: 'Cancelled',
    unpaid: 'Unpaid',
    overdue: 'Overdue',
    paid: 'Paid',
    partially_paid: 'Partially Paid',
  };

  static INVOICE_TYPE_ITEM_DETAIL = 'item_detail';

  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
    };
  }

  render() {
    const { outlets, showModalOutletMobileState } = this.props;

    return (
      <div>
        <div className="col-md-12 no-padding">
          <MenuTitle menuTitle="Invoice" />
          {!isFullSiteMode() && (
            <div className="col-md-6 col-lg-6 col-xs-6 col-sm-6 no-padding visible-md visible-lg export-invoice">
              <div className="pull-right dropdown-export">
                <Dropdown>
                  <Dropdown.Toggle
                    title="Export"
                    bsStyle="primary"
                  ></Dropdown.Toggle>
                  <Dropdown.Menu>
                    <MenuItem onSelect={this._onClickExportButton}>
                      Transactions
                    </MenuItem>
                    <MenuItem divider />
                    <MenuItem
                      onSelect={this._onClickExportButton}
                      eventKey={ActionBar.INVOICE_TYPE_ITEM_DETAIL}
                    >
                      Item Details
                    </MenuItem>
                  </Dropdown.Menu>
                </Dropdown>
              </div>
            </div>
          )}
        </div>
        <div style={{ paddingTop: '20px' }}>
          <div className="col-sm-12 col-xs-12 no-padding">
            <div
              className={`${
                styleActionBar['form-group']
              } form-group pull-left visible-md visible-lg`}
            >
              <Field
                component={DropdownOutlet}
                outlets={outlets}
                onChangeOutletIds={this._onChangeOutlet}
                name="outlet"
                allOutletOption
              />
            </div>
            <div
              className={`${
                styleActionBar['form-group']
              } calendar-dashboard pull-left`}
            >
              <Field
                component={DropdownCalendar}
                name="date"
                onChange={this._onChangeDate}
                updateServerOnChange
              />
            </div>
            <div
              className={`${
                styleActionBar['form-group']
              }  visible-md visible-lg pull-left`}
            >
              <Field
                component={MultipleDropdownSelect}
                name="statuses"
                onChange={this._onChangeStatuses}
                options={ActionBar.INVOICE_STATUS}
                placeholder="Select Status"
              />
            </div>
            <div
              className={`${
                styleActionBar['form-group']
              }  visible-md visible-lg pull-left`}
            >
              <Field
                component={SearchBar}
                name="keyword"
                onChange={this._onChangeKeyword}
                placeholder="Search"
              />
            </div>
            <Field
              component={OutletModal}
              name="outlet"
              outlets={outlets}
              onChangeOutletIds={this._onChangeOutlet}
              allOutletOption
              show={showModalOutletMobileState}
            />
          </div>
        </div>
      </div>
    );
  }

  _onChangeOutlet = outletIds => {
    this.props.onChangeOutlet(outletIds);
  };

  _onChangeDate = ({ startDate, endDate, startHour, endHour, allDay }) => {
    this.props.onChangeDate({ startDate, endDate, startHour, endHour, allDay });
  };

  _onChangeStatuses = (event, statuses) => {
    this.props.onChangeStatuses(statuses);
  };

  _onChangeKeyword = (event, keyword) => {
    this.props.onChangeKeyword(keyword);
  };

  _onClickExportButton = reportType => {
    const {
      startDate,
      endDate,
      startHour,
      endHour,
      allDay,
    } = this.props.search.date;
    const { outlet } = this.props.search;
    const { statuses } = this.props.search;
    const { keyword } = this.props.search;

    const { formattedStart, formattedEnd } = getFormattedTime(
      startDate,
      endDate,
      startHour,
      endHour,
      allDay
    );
    const query = {
      start: formattedStart,
      end: formattedEnd,
      status: statuses,
      keyword,
      view: reportType,
    };
    const format = allDay ? 'DD-MM-YYYY' : 'DD-MM-YYYY HH:mm:ss';
    let dateLabel = '';
    if (moment(startDate).isSame(moment(endDate), 'days')) {
      dateLabel = allDay
        ? moment(formattedStart).format(format)
        : [
            moment(formattedStart).format(format),
            moment(formattedEnd).format('HH:mm:ss'),
          ].join(' - ');
    } else {
      dateLabel = [
        moment(formattedStart).format(format),
        moment(formattedEnd).format(format),
      ].join(' - ');
    }

    let filename = `Report Invoice Transactions - ${dateLabel}`;
    if (reportType === ActionBar.INVOICE_TYPE_ITEM_DETAIL) {
      filename = `Report Invoice Item Details - ${dateLabel}`;
    }

    this.props.dispatch(exportInvoices(query, filename, outlet[0]));
  };
}

const mapForm = {
  form: 'search',
};

function mapStateToProps(state) {
  return {
    outlets: state.reports.invoices.outlets,
    showModalOutletMobileState: state.moka.showModalOutletMobile,
  };
}

function mapDispatchToProps(dispatch) {
  return { dispatch };
}

ActionBar.propTypes = {
  onChangeOutlet: PropTypes.func,
  onChangeDate: PropTypes.func,
  onChangeStatuses: PropTypes.func,
  onChangeKeyword: PropTypes.func,
};

export default reduxForm(mapForm)(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(ActionBar)
);
